import React, { useState } from "react"
import { FiArchive, FiArrowDown, FiBell, FiBellOff, FiCheck, FiChevronDown, FiFlag, FiImage, FiMenu, FiMic, FiMoreHorizontal, FiMoreVertical, FiPause, FiPhone, FiPlay, FiPlus, FiRepeat, FiSearch, FiSend, FiSmile, FiTrash, FiTrash2, FiUser, FiUsers, FiVideo, FiVolume, FiVolumeX, FiX, FiXOctagon } from "react-icons/fi"
import clx from "classnames"
import neonStore from '../../../../stores/useNeon'
import { EmojiPicker } from "../../messsenger/content/emojipicker"

export const Send = ({
    
}) => {
  const {addMessage} = neonStore(state=>state)
  const [message, setMessage] = useState('');
  const [updated, setUpdated] = useState('');

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      setUpdated(message);
      const object = {
        sort:6,
        user:{
          name:"Development Team",
          avatar:"/images/avatars/Vector-13.png",
          foreground:'#f24e1e',
        },
        date:"2023-07-18T12:00:00-11:03",
        messages:[
            message,
        ],
      } 
      addMessage(object, message)
      setMessage('')

    }
  };

    return (
        <React.Fragment>
            <div
                className="send dark:bg-[#141618]/20 bg-white/20 backdrop-blur-md sticky bottom-4 left-0 right-0 z-30"
            >
                <div className="mb-4 mx-4 flex flex-col gap-2">

                    <Record />
                    <Typing />

                    <div className="flex items-center">
                        <div
                        className="bg-gray-100 dark:bg-[#1e2126] flex items-center w-full p-3 px-6 rounded-md"
                        >
                        <div className="flex gap-3">
                         

                            <EmojiPicker />


                            <FiMic size={23}
                            className="stroke-gray-500 cursor-pointer"/>
                        </div>
                        <textarea
                            onInput={e=>{
                            e.target.style.height = "1px";
                            e.target.style.height = (e.target.scrollHeight)+"px";

                            }}
                            value={message}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            id="message"
                            name="message"
                            type="text"
                            placeholder="Type something"
                            className="auto_height overflow-y-hidden p-3 border-none outline-none bg-transparent w-full"
                            rows="1"
                        ></textarea>
                        <div className="flex items-center gap-4 ml-4">
                            <FiImage size={23}
                            className="cursor-pointer stroke-gray-500"/>
                            <div className="group">
                            <div
                                className="flex items-center justify-center p-2 rounded-md flex items-center justify-center"
                            >
                                <FiSend size={23}
                                className="cursor-pointer stroke-gray-500 dark:stroke-zinc-500"
                                />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}


export const Typing = () => {

    return (
        
        <div className="flex gap-2 items-end cursor-pointer mt-2">
            <img
            src="/images/avatars/Vector-15.png"
            className="h-8 w-8 rounded-full"
            />
            <div>
            <div
                className="flex gap-5 items-center typing bg-blue-600 rounded-xl p-3 pr-7 angle"
            >
                <p className="font-medium">Typing</p>
                <div className="snippet" data-title="dot-typing">
                <div className="stage">
                    <div className="dot-typing"></div>
                </div>
                </div>
            </div>

            <div className="mt-2 text-sm">Jane Doe</div>
            </div>
        </div>
    )
}


export const Record = () => {
    return (
        <React.Fragment>
        </React.Fragment>
    )
}